import React, {useEffect, useState} from 'react';

import {mediaInfo} from 'methods/forms';
import * as utils from 'methods/site.js';

import FormDynamic from 'components/forms/FormDynamic';

export default (props) => {
  const [fieldsMedia, setFieldsMedia] = useState(null);
  const [formMedia, setFormMedia] = useState(null);

  useEffect(() => {
    //setFieldsMedia(mediaInfo(null, null, null, props.mediaInfo ? props.mediaInfo : null));
    setFieldsMedia([
      {field_type: 'text',
      field_name: 'media_caption',
      field_label: 'Title or caption',
      field_placeholder: 'Title or caption',
      field_value: utils.objExists(props.mediaInfo, 'media_caption') ? props.mediaInfo.media_caption : null,
      field_required: false,
      field_validate: false,
      field_order: 1,
      field_focus: true,
      },
      {field_type: 'textarea',
      field_name: 'media_description',
      field_label: 'Description',
      field_placeholder: 'Description',
      field_value: utils.objExists(props.mediaInfo, 'media_description') ? props.mediaInfo.media_description : null,
      field_required: false,
      field_validate: false,
      field_order: 2,
      },
      {field_type: 'switch',
      field_name: 'media_frame',
      field_label: 'Use Frame?',
      field_value: utils.objExists(props.mediaInfo, 'media_frame') && props.mediaInfo.media_frame === 1 ? true : false,
      field_required: false,
      field_validate: false,
      field_order: 3,
      },
      {field_type: 'switch',
      field_name: 'media_published',
      field_label: 'Publish',
      field_value: utils.objExists(props.mediaInfo, 'media_published') && props.mediaInfo.media_published === 1 ? true : false,
      field_required: false,
      field_validate: false,
      field_order: 4,
      },
      {field_type: 'switch',
      field_name: 'media_default',
      field_label: 'Default Image',
      field_value: utils.objExists(props.mediaInfo, 'media_default') && props.mediaInfo.media_default === 1 ? true : false,
      field_required: false,
      field_validate: false,
      field_order: 5,
      },
    ]);
  }, [props.mediaInfo]);

  useEffect(() => {
    if(fieldsMedia) {
      setFormMedia(
        <FormDynamic {...props}
                      content={[{fieldset_name: `Edit media info`, fields: fieldsMedia}]}
                      returnObject={true}
                      fieldOnChange={handleChange}
                      formActions={{formCancel: handleCancel, formSubmit: handleEdit}} />
      )
    }
  }, [fieldsMedia]);


// FUNCTIONS
  function handleCancel(e) {
    if(props.actionCancel) {
      props.actionCancel(e);
    }
  }

  function handleChange(e) {
    console.log("We're handling change!!");
  }

  function handleEdit(params) {
    props.mediaInfo &&
    params.push({name: 'media_id', value: props.mediaInfo.media_id});
    props.objExists(props.mediaInfo, 'text_id') &&
    params.push({name: 'text_id', value: props.mediaInfo.text_id});
    props.objExists(props.mediaInfo, 'media_type') &&
    params.push({name: 'media_type', value: props.mediaInfo.media_type});
    params.push({name: 'process', value: props.objExists(props.mediaInfo, 'text_id') ? 'update_media' : 'add_media_text'});

    if(props.actionEdit) {
      props.actionEdit(params);
    }
  }

  return (formMedia);
}
